module.exports = __webpack_public_path__ + "9dbeafac58544d21e6218d814e249c03.png";